import { RAuditConfig } from '@counsel-project/counsel-audit-backend-api'

// Serialize with object keys sorted so property insertion order (which spreads
// can change) never produces false positives in deep-equality comparisons.
export const stableStringify = (value: unknown): string =>
  JSON.stringify(value, (_key, val: unknown) =>
    val && typeof val === 'object' && !Array.isArray(val)
      ? Object.keys(val)
          .sort((a, b) => a.localeCompare(b))
          .reduce<Record<string, unknown>>((sorted, key) => {
            sorted[key] = (val as Record<string, unknown>)[key]
            return sorted
          }, {})
      : val
  )

export const getAuditConfigSavingProblems = (config: RAuditConfig | null) => {
  const problems: string[] = []
  if (!config) {
    problems.push('No configuration found')
  }
  for (const measure of config?.measures ?? []) {
    if (!measure.title) {
      problems.push('Measure title is required')
    }
    if (!measure.description) {
      problems.push('Measure description is required')
    }
    if (measure.severity === undefined) {
      problems.push('Measure severity is required')
    }
    if (measure.severity < -1 || measure.severity > 3) {
      problems.push('Invalid measure severity level')
    }
  }
  return problems
}
